<template>
  <app-modal
    :modal-id="modalId"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ modalTitle }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
          selectedUrl
            ? `/accreditations/officio/store/${inputs.id}`
            : `/accreditations/officio/store`
        "
      >
        <div class="row">
          <div class="col-md-12 mb-5">
            <h5 class="card-title m-0">{{ "1. " + $t("type_request") }}</h5>
          </div>
        </div>
        <div class="form-group row align-items-center">
          <label for="inputs_accreditation_area_id" class="col-sm-3 mb-0">
            {{ $t("accreditation_area") }}
          </label>
          <app-input
            id="inputs_accreditation_area_id"
            class="col-sm-9"
            type="select"
            v-model="inputs.accreditation_area_id"
            :list="accreditationAreaList"
            v-on:change="onChangeAccreditationArea"
            :required="true"
          />
        </div>

        <div class="form-group row align-items-center">
          <label for="inputs_accreditation_activity_id" class="col-sm-3 mb-0">
            {{ $t("activity") }}
          </label>
          <app-input
            id="inputs_accreditation_activity_id"
            class="col-sm-9"
            type="select"
            v-model="inputs.accreditation_activity_id"
            v-on:change="onChangeActivity"
            :list="accreditationActivityLists"
            :required="true"
          />
        </div>
        <!-- <div class="form-group row align-items-center" v-if="inputs.accreditation_activity_id == 12 && essay.accreditation_activity_id == 12"> -->
        <div class="form-group row align-items-center" v-if="inputs.accreditation_activity_id == 12">
          <label for="inputs_accreditation_activity_id" class="col-sm-3 mb-0">
            Ensayo
          </label>
          <app-input
            id="inputs_accreditation_activity_id"
            class="col-sm-9"
            type="select"
            v-model="inputs.selectedEssay"
            :list="essayLists"
          />
        </div>
        <div class="row">
          <div class="col-md-12 mb-5">
            <hr />
            <h5 class="card-title m-0">
              {{ "2. " + $t("Tipo de Oficio") }}
            </h5>
          </div>
        </div>


        <div class="form-group row align-items-center">
          <label for="inputs_accreditation_type_id" class="col-sm-3 mb-0">
            {{ $t("Tipo de Oficio") }}
          </label>
          <app-input
            id="inputs_accreditation_type_id"
            class="col-sm-9"
            type="select"
            v-model="inputs.accreditation_type_id"
            :list="accreditationRequestRS"
            :required="true"
          />
        </div>

        <div class="row">
          <div class="col-md-12 mb-5">
            <hr />
            <h5 class="card-title m-0">
              {{
                "3. RESPONSABILIDAD SOBRE USO DE INFORMACIÓN SISTEMA INFORMATICO SISAC DEL SAE "
              }}
            </h5>
            <br>
            <p>
              El usuario interno o externo del sistema SISAC del SAE es
              responsable del uso de su clave, así como de la veracidad y
              autenticidad de la información proporcionada en la gestión de
              trámites administrativos.  Debe verificar la exactitud de sus
              declaraciones.
            </p>
            <p>
              La información y documentación incorporada y/o generada en el
              sistema informático SISAC del SAE, para el proceso de
              acreditación, cumple con los requisitos de legalidad y aceptación
              de las partes, sin que el registro de firmas se considere como
              requisito de cumplimiento y atención de servicio. 
            </p>
            <p>
              Queda amparado dentro de las condiciones de comercio electrónico,
              transacciones electrónicas y aceptación correspondiente de las
              partes. Se reitera que la ausencia de firmas no resta la legalidad
              y eficacia del acto administrativo, lo cual está siendo aceptado
              por el representante legal del OEC.
            </p>
            <p>
              El usuario y clave para el ingreso al sistema informático SISAC
              son de exclusiva responsabilidad de la entidad y usuario
              registrado para efectos de la acreditación, por lo cual se libera
              de responsabilidad al Servicio de Acreditación Ecuatoriano SAE, en
              caso del mal uso de la misma.
            </p>
            <p>
              El usuario debe actuar con la debida diligencia y tomar las
              medidas de seguridad necesarias, para mantener su usuario y clave
              bajo su estricto control y evitar toda utilización no autorizada;
              debe notificar al SAE, cuando exista el riesgo de que su usuario y
              clave sea controlada por terceros no autorizados y utilizada
              indebidamente.
            </p>
            <p>
              El usuario responde por las obligaciones derivadas del uso no
              autorizado de su clave, cuando no hubiere obrado con la debida
              diligencia para impedir su utilización"
            </p>
          </div>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button
        type="button"
        class="btn btn-primary"
        @click="submit"
        :disabled="disabledSubmit"
      >
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  name: "ApplicacionOfficioModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    accreditationAreaList: Array,
    accreditationActivityList: Array,
    accreditationTypeList: Array,
    accreditationRequestRS: Array,
  },
  data() {
    return {
      preloader: false,
      inputs: {},
      modalId: "application-officio-rs-modal",
      modalTitle: "Oficio Voluntario",
      accreditationActivityLists: [{ id: "", value: this.$t("select_option") }],
      formRowInstruction: [this.$t("type_request")],
      disabledSubmit: false,
      vigilanceSelected: null,
      vigilanceList: [],
      titleList: "",
      statusToAcc: null,
      essay: {},
      essayLists: [
        { id: "", value: this.$t("ENSAYOS") },
        { id: "inv", value: "INVESTIGACIÓN Y CONTROL DE CALIDAD" },
      ],
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      this.disabledSubmit = true;
      this.save(this.inputs);

    },
    onChangeActivity(){
     this.getVigilances();
     this.getRenovation();
     if (this.inputs.accreditation_activity_id == 12){
        this.showEssay();
     }
    },
    onChangeTypeAccreditation(){
      this.getVigilances();
      this.getRenovation();
    },
    getVigilances(){

      if (this.inputs.accreditation_activity_id && this.inputs.accreditation_type_id == '10'){
        this.titleList = 'Vigilancia';
        const url = `/accreditations/applications/get-vigilances/${this.inputs.accreditation_activity_id}`;
        this.vigilanceList = [{ id: "", value: this.$t("select_option") }];
        this.vigilanceSelected = null;
        this.preloader = true;
        this.axiosGet(url)
            .then((response) => {
              for (const v of response.data) {
                this.vigilanceList.push({id: v.id, value: v.accreditation_type.name})
              }
              this.statusToAcc = 10;
              this.preloader = false;
            })
            .catch(({ error }) => {});
      }


    },
    getRenovation(){
      if (this.inputs.accreditation_activity_id && this.inputs.accreditation_type_id == '11'){
        this.titleList = 'Renovación';
        const url = `/accreditations/applications/get-renovation/${this.inputs.accreditation_activity_id}`;
        this.vigilanceList = [{ id: "", value: this.$t("select_option") }];
        this.vigilanceSelected = null;
        this.preloader = true;
        this.axiosGet(url)
            .then((response) => {
              for (const v of response.data) {
                this.vigilanceList.push({id: v.id, value: v.accreditation_type.name})
              }
              this.statusToAcc = 11;
              this.preloader = false;
            })
            .catch(({ error }) => {});
      }
    },
    afterJsValidationFail() {
      this.disabledSubmit = false;
    },

    afterSuccess({ data: res }) {
      // this.$toastr.s(response.data.message);



      if (res.data == "OK") {
        this.$toastr.s(this.$t("created_success"));
        this.$hub.$emit("reload-" + this.tableId);
      } else if(res.data == "noAccInit"){
        this.$toastr.e(
            "No podrá crear esta solicitud hasta finalizar el proceso de acreditación inicial"
        );
      } else if(res.data == "noLicense"){
        this.$toastr.e(
            "Para crear una nueva Solicitud es necesario que finalice la verificación del pago de licencia"
        );
      } else {
        this.$toastr.e(
          "No existen alcances definidos para este tipo de formulario, por favor contacte a su administrador de sistema"
        );
      }
    },

    afterSuccessFromGetEditData(response) {
      this.inputs = response.data;
      this.onChangeAccreditationArea();
      this.preloader = false;
    },
    onChangeAccreditationArea() {
      this.accreditationActivityLists = [
        { id: "", value: this.$t("select_option") },
        ...this.accreditationActivityList.filter((item) => {
          return item.parent == this.inputs.accreditation_area_id;
        }),
      ];
    },
    showEssay() {
      let url = `/accreditations/applications/showEnsayo/${1}`;
      this.axiosGet(url).then((response) => {
        this.essay = response.data;
      });
    }
  },
};
</script>
